import { User } from "../../../vas/business-objects/user/user.model";
import { NetworkStatus } from "../network/network-status";
import { isDefined } from "ionic-angular/util/util";

export class Session {

    constructor(protected user: User, protected networkStatus: NetworkStatus) {

    }

    getUser(): User {
        return this.user;
    }

    isSignedIn(): boolean {
        return isDefined(this.user);
    }

    getNetworkStatus(): NetworkStatus {
        return this.networkStatus;
    }
}



// WEBPACK FOOTER //
// ./src/core/business-objects/session/session.model.ts